<template>
  <div class="listing">
    <loader class="imageLoader" :loading="loading" />
    <header class="header">
      <div class="header__Search">
        <form class="search">
          <input class="search__Text" type="search" placeholder="Enter tag name and press enter" />
          <button class="search__Button">
            <icon name="search"></icon>
          </button>
        </form>
      </div>
    </header>
    <section class="page">
      <header class="pageHeader">
        <div class="pageHeader__Inner">
          <h1 class="pageHeader__Title">{{ $store.getters.getStringTranslation('quizes') }}</h1>

          <ul class="pageHeader__Meta">
            <li>
              <router-link class="button" :to="{ name: 'Add quiz' }">{{
                $store.getters.getStringTranslation('addQuiz')
              }}</router-link>
            </li>
          </ul>
        </div>
      </header>

      <transition name="fade">
        <router-view :propLanguage="lang" v-if="loading === false"></router-view>
      </transition>

      <div class="tab">
        <div class="tab__Wrapper">
          <div class="tab__Item">
            <div class="tab__Content">
              <table class="postsTable" v-if="items.resources && items.resources.length > 0">
                <thead>
                  <tr>
                    <th>{{ $store.getters.getStringTranslation('title') }}</th>
                  </tr>
                </thead>
                <tbody v-for="item in items.resources" :key="item.id">
                  <tr>
                    <td>
                      <label for="" class="postsTable__ItemTitle">{{ getTranslation(item.l10n, 'title') }}</label>

                      <ul class="postsTable__ItemActions">
                        <li>
                          <router-link :to="{ name: 'Edit quiz', params: { id: item.id }, query: { lang } }" append
                            >Edit</router-link
                          >
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="error" v-else-if="errors && errors.length > 0">
                <p>Something went wrong! Please let our administrators know of the problems below.</p>

                <pre>{{ errors }}</pre>
              </div>

              <div class="error" v-else-if="items.resources && items.resources.length === 0 && loading === false">
                <p>Sorry, no content matched your criteria.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Loader from '@/components/partials/Loader.vue'
import FetchFeed from '@/components/mixins/FetchFeed.js'
import GetTranslation from '@/components/mixins/GetTranslation.js'

export default {
  name: 'Quizes',
  data() {
    return {
      errors: [],
      items: [],
      loading: false,
    }
  },
  mixins: [FetchFeed, GetTranslation],
  computed: {
    lang() {
      const query = this.$route.query
      if (query.search && JSON.parse(query.search).lang) return JSON.parse(query.search).lang
      return this.$store.state.ui.lang
    },
  },
  mounted() {
    this.fetchFeed({ types: ['quiz'] })
  },
  components: {
    Loader,
  },
}
</script>
